import { Build } from '@todesktop/shared';
import { Box, Text } from 'ink';
import TextInput from 'ink-text-input';
import { useState } from 'react';
import { MIN_RUNTIME_VERSION_FOR_DOWNGRADE } from '../utilities/analyzeRelease';

export default function DowngradeConfirmation({
  build,
  latestReleasedBuild,
  confirmDowngrade,
}: {
  build: Build;
  latestReleasedBuild: Build;
  confirmDowngrade: () => void;
}) {
  const [confirmText, setConfirmText] = useState('');
  const [showError, setShowError] = useState(false);

  const buildVersion = build.appVersion;
  const latestVersion = latestReleasedBuild.appVersion;

  function onType(text: string) {
    setShowError(false);
    setConfirmText(text);
  }

  function onSubmit(text: string) {
    if (text.trim() === buildVersion) {
      confirmDowngrade();
    } else {
      setShowError(true);
    }
  }

  return (
    <Box flexDirection="column">
      <Box borderColor="red" borderStyle="double" paddingX={1}>
        <Text>
          You&apos;re trying to release the build {buildVersion}, which is older
          than the latest published version {latestVersion}. This may cause
          issues if your customers are using a version of your desktop app that
          contains a version of @todesktop/runtime that is earlier than v
          {MIN_RUNTIME_VERSION_FOR_DOWNGRADE}.
        </Text>
      </Box>

      <Box marginTop={1}>
        <Text>Are you sure that you wish to release this build?</Text>
      </Box>

      <Box marginTop={1}>
        <Text>
          To continue, type the text <Text bold>{buildVersion}</Text> below to
          confirm:
        </Text>
      </Box>

      <Box>
        <Box marginRight={1}>
          <Text>Confirm new version:</Text>
        </Box>

        <TextInput value={confirmText} onChange={onType} onSubmit={onSubmit} />
      </Box>

      {showError && (
        <Box>
          <Text color="red">You&apos;ve entered the wrong version</Text>
        </Box>
      )}
    </Box>
  );
}
